import React, { memo, useEffect, useState } from 'react';
import { Button, Card, CircularProgress, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import useTopPanel from 'hooks/useTopPanel';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';

const DEFAULT_URL = 'https://backai.smartsales.uz';

const SsaiSettings = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const sendNotification = useNotification();

  const [item, setItem] = useState(null); // {id, url, key, domain}
  const [key, setKey] = useState('');
  const [url, setUrl] = useState(DEFAULT_URL);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setComponent(<div className='component-title'>SSAi</div>);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const { isLoading, isFetching } = useQuery({
    queryKey: ['ssai-integration-setting'],
    queryFn: async () => {
      const res = await axiosPrivate.get('/crm/integration-setting');
      return res.data.data;
    },
    onSuccess: (list) => {
      const found = (list || []).find((x) => x.type === 'ssai');
      if (found) {
        setItem(found);
        setKey(found.key || '');
        setUrl(found.url || DEFAULT_URL);
      }
    },
    retry: false,
  });

  const save = async () => {
    if (!item?.id || saving) return;
    if (!key || key.trim().length < 3) {
      sendNotification({ msg: 'Token (kalit) kiriting', variant: 'warning' });
      return;
    }
    setSaving(true);
    try {
      await axiosPrivate.put(`/crm/integration-setting/${item.id}`, {
        url: (url || DEFAULT_URL).trim(),
        domain: 'ssai',
        key: key.trim(),
      });
      sendNotification({ msg: 'Saqlandi', variant: 'success' });
    } catch (e) {
      sendNotification({ msg: 'Xatolik', variant: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className='component-list-wrapper'>
      <Card className='!p-5 !mt-4' sx={{ maxWidth: 560 }}>
        {isLoading || isFetching ? (
          <div className='flex items-center justify-center py-8'>
            <CircularProgress size={28} />
          </div>
        ) : !item ? (
          <div className='text-center text-gray-400 py-6'>
            SSAi sozlamasi topilmadi (migratsiyani ishga tushiring).
          </div>
        ) : (
          <div className='flex flex-col gap-4'>
            <TextField
              label='SSAi URL'
              fullWidth
              size='small'
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder={DEFAULT_URL}
            />
            <TextField
              label='API token (Bearer)'
              fullWidth
              size='small'
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder='Kompaniya SSAi tokeni'
            />
            <div className='text-xs text-gray-400'>
              Token bo'sh bo'lsa qo'ng'iroqlar SSAi'ga yuborilmaydi.
            </div>
            <div>
              <Button
                variant='contained'
                color='primary'
                onClick={save}
                disabled={saving}
              >
                {saving ? (
                  <CircularProgress size={18} color='inherit' />
                ) : (
                  t('common.button.save')
                )}
              </Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default memo(SsaiSettings);
